module.exports = __webpack_public_path__ + "img/NDTVPrime.5bda7910.jpg";